module.exports = __webpack_public_path__ + "facelifting_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_5_after.jpg
// module id = 1057
// module chunks = 0